import { render } from "./ReferenceView.vue?vue&type=template&id=512a2ef7"
import script from "./ReferenceView.vue?vue&type=script&lang=js"
export * from "./ReferenceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__